module.exports = __webpack_public_path__ + "img/logo-all.446b2185.png";